<ul class="nav nav-tabs nav-pills nav-justified">
    <li class="nav-item">
      <a class="nav-link"  [routerLink]="['formulario']"
        >Formularios</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['formulariora']">Formulario de RA</a>
    </li>
  </ul>